import dayjs from "dayjs";
import { Fragment } from "react/jsx-runtime";

const keyRender = [
  {
    label: "RFS Date",
    value: "RFSdate",
  },
  {
    label: "Due Date",
    value: "dueDate",
  },
  {
    label: "Customer name",
    value: "customerName",
  },
  {
    label: "Customer Project Number",
    value: "customerProjectNumber",
  },
  {
    label: "End Customer Name",
    value: "endCustomerName",
  },
  {
    label: "Quote request Date",
    value: "createdAt",
  },
  {
    label: "Local Contact Name",
    value: "localContactName",
  },
  {
    label: "Local Contact Number",
    value: "localContactNumber",
  },
];

export default function QuoteLineHeaderElement({
  value,
  keyIdentifier,
  dataType,
}: {
  value: string;
  keyIdentifier: string;
  dataType: "string" | "time";
}) {
  const renderData = keyRender.find((el) => el.value === keyIdentifier);
  return (
    <>
      {renderData && (
        <Fragment key={keyIdentifier}>
          <span className="text-blackTransparent-60">{renderData.label}</span>
          <span className="text-black">
            {dataType === "time" ? dayjs(value).format("DD.MM.YYYY") : value}
          </span>
        </Fragment>
      )}
    </>
  );
}
//quoteLine/vendor/532/109792
